import { useEffect } from 'react'

import CajaTemplate from 'Components/UI/Templates/Sales/Caja'

const Caja = () => {
  useEffect(() => {
    document.title = 'Caja diaria'
  }, [])
  return <CajaTemplate />
}

export default Caja
